document.addEventListener("DOMContentLoaded", function () {
    // Obtén la lista y el elemento activo
    var stepsNav = document.querySelector(".header-step .steps_counter--nav");
    var activeElement = stepsNav.querySelector(".steps_counter--nav .active");
  
    // Desplaza hasta el elemento activo
    if (activeElement) {
      stepsNav.scrollLeft = activeElement.offsetLeft - (stepsNav.offsetWidth - activeElement.offsetWidth) / 2;
    }
  });